<template>
  <div style="margin: auto">
    <div style="width: 430px" class="col-12">
      <div class="card mb-4 text-center p-2">
        <div class="card-body">
          <!-- Logo -->
          <div class="mb-4">
            <img :src="image" alt="Takaful Brunei" style="width: 50%" />
          </div>

          <!-- Form -->
          <!-- <h1 class="mb-3 text-18">Login</h1> -->
          <div class="form-group mb-3">
            <label for="email">Email / Username</label>
            <input
              class="form-control"
              type="email"
              name="email"
              id="email"
              v-model="user.email"
              autocomplete="off"
            />
          </div>

          <div class="form-group mb-3">
            <label for="password">Password</label>
            <div class="input-group">
              <input
                v-on:keyup.enter="login"
                class="form-control"
                v-bind:type="[showPassword ? 'text' : 'password']"
                name="password"
                id="password"
                aria-describedby="inputGroupPrepend"
                v-model="user.password"
                autocomplete="off"
              />
              <div class="input-group-prepend" @click="toggle">
                <span class="input-group-text"
                  ><i
                    class="fa"
                    :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                    aria-hidden="true"
                  ></i
                ></span>
              </div>
            </div>
          </div>

          <!-- Button -->
          <button
            :disabled="disableBtn"
            @click="login"
            class="btn btn-rounded btn-primary btn-block mt-3 mb-1"
          >
            Login
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Auth from "@/services/Auth";

let auth = new Auth();

export default {
  name: "login",
  components: {},
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      image: require("@/assets/icons/logo-tb.png"),
      showPassword: false,
      disableBtn: false
    };
  },

  methods: {

    async login() {
      this.disableBtn = true;

      try {
        let response = await auth.login(this.user);

        if(response.data.success === false) {
          throw new Error(response.data.message);
        }

        if (response.data.success === true && response.data.roles.includes("Customer")) {
          throw new Error("You are a customer");
        }

        sessionStorage.setItem("preUser", JSON.stringify(response.data.user));
        sessionStorage.setItem("preToken", JSON.stringify(response.data.token));
        sessionStorage.setItem("roles", JSON.stringify(response.data.roles));

        this.reset();

        this.$router.push("auth_otp");
      } catch (e) {
        swal({
          icon: "error",
          text: e.response != undefined ? e.response.data.message : e.message
        })
        this.reset();
        this.disableBtn = false;
        console.log(e);
      }
    },

    toggle() {
      // this.showPassword != this.showPassword
      if (this.showPassword) {
        this.showPassword = false;
      } else {
        this.showPassword = true;
      }
    },

    reset() {
      this.user.email = "";
      this.user.password = "";
    }
  },

  created() {
    sessionStorage.removeItem("preToken");
    sessionStorage.removeItem("preUser");
    sessionStorage.removeItem("roles");
  },
};
</script>
